export const colors = {
  red: "#FF4A60",
  green: "#40CC81",
  dark: "#1c1c25",
  white: "#ffffff",
};

// 默认的绿色主题颜色
export const antdPrimaryTheme = {
  colorBg: "#f6f0ff",
  colorBgHover: "#f5f0ff",
  colorBorder: "#ece3ff",
  colorBorderHover: "#cfbaff",
  colorHover: "#a88cf5",
  color: "#8060E8",
  colorActive: "#5f46c2",
  colorTextHover: "#fff",
  colorText: "#8060e8",
  colorTextActive: "#fff",
};
